// src/components/Tarot.jsx
import React, { useState, useEffect, useCallback } from "react";
import axios from 'axios';
import { cards } from "../data/cards"; // Dein Karten-Deck
import "../styles/global.css";
import Legemuster from "../data/Legemuster";

const cardBack = "/cardBack-test.jpg";
const API_URL = "https://tarot-website.alina-goettig.workers.dev";
const layouts = Legemuster;
const SPLIT_THRESHOLD = 40; // Kartenanzahl, ab der in zwei Reihen aufgeteilt wird


const Tarot = () => {
    const [shuffledDeck, setShuffledDeck] = useState([]);
    const [selectedCards, setSelectedCards] = useState([]);
    const [tarotText, setTarotText] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showDeck, setShowDeck] = useState(true);
    const [showText, setShowText] = useState(false);
    const [selectedLayout, setSelectedLayout] = useState(Object.keys(layouts)[0] || "");

    const resetTarot = () => {
        setShuffledDeck([...cards].sort(() => Math.random() - 0.5));
        setSelectedCards([]);
        setShowDeck(true);
        setShowText(false);
        setTarotText("");
        setError("");
    };

    const getTarotReading = useCallback(async () => {
        try {
            setLoading(true);
            setError("");

            console.log("Sende Anfrage an API mit Karten:", selectedCards);

            // Dynamischer Prompt basierend auf Legung und Karten
            const layoutDescription = layouts[selectedLayout].description;
            let context = `Alles`;
            let prompt = `Du bist ein erfahrener Tarot-Experte. Beachte folgendes:
            - Halte dich kurz, aber volle Sätze.
            - Kartenname & Position: Bedeutung variiert je nach Lage.
            - Verbindungen: Karten beeinflussen sich gegenseitig.
            - Kernaussage & Details: Gib eine klare Hauptaussage mit ergänzenden Infos.
            - Legung (${selectedLayout}): ${layoutDescription}
            - Thema: ${context} – Fokus darauf, aber andere Aspekte nicht ignorieren.
            - Gezogene Karten:`;

            selectedCards.forEach((card, index) => {
                prompt += `Karte ${index + 1}: ${card.name}\n`;
            });

            // Prüfe den Prompt bevor die Anfrage gesendet wird
            console.log("Prompt Länge:", prompt.length);
            console.log("Prompt für die API:", prompt);

            const response = await axios.post(API_URL, {
                prompt: prompt,  // Der dynamische Prompt
            });

            console.log("Antwort vom Server:", response.data);

            if (response.data && response.data.interpretation) {
                setTarotText(response.data.interpretation);
            } else {
                setError("Keine gültige Antwort vom Server.");
            }
        } catch (error) {
            console.error("Fehler beim Abrufen der Tarot-Legung:", error);
            console.error("Fehlerdetails:", error.response?.data || error.message);
            setError("Es gab ein Problem mit der Tarot-Interpretation.");
        } finally {
            setLoading(false);
        }
    }, [selectedCards, selectedLayout]);


    const handleLayoutChange = (e) => {
        setSelectedLayout(e.target.value);
        setSelectedCards([]);
    };

    const handleCardClick = (card) => {
        if (!layouts[selectedLayout] || selectedCards.length >= layouts[selectedLayout].cards) return;
        setSelectedCards([...selectedCards, card]);
    };

    useEffect(() => {
        if (selectedCards.length === layouts[selectedLayout]?.cards) {
            setTimeout(() => {
                setShowDeck(false);
                getTarotReading();
                setTimeout(() => setShowText(true), 1000);
            }, 1000);
        }
    }, [selectedCards, getTarotReading, selectedLayout]);

    useEffect(() => {
        setShuffledDeck([...cards].sort(() => Math.random() - 0.5));
    }, []);

// Aufteilen der Karten in zwei Reihen, wenn notwendig
const splitDeck = () => {
    if (shuffledDeck.length > SPLIT_THRESHOLD) {
        const midIndex = Math.ceil(shuffledDeck.length / 2);
        return {
            firstRow: shuffledDeck.slice(0, midIndex),
            secondRow: shuffledDeck.slice(midIndex),
        };
    }
    return {
        firstRow: shuffledDeck,
        secondRow: [],
    };
};

const { firstRow, secondRow } = splitDeck();

    return (
        <div className="tarot-container">
            <select onChange={handleLayoutChange} value={selectedLayout}>
                {Object.keys(layouts).map((layoutKey) => (
                    <option key={layoutKey} value={layoutKey}>
                        {layoutKey} ({layouts[layoutKey].cards} Karten)
                    </option>
                ))}
            </select>

            {showDeck && (
                <div className="tarot-deck">
                    {/* Erste Reihe */}
                    <div className="tarot-row">
                        {firstRow.map((card, index) => (
                            <div
                                key={index}
                                className="tarot-card"
                                onClick={() => handleCardClick(card)}
                            >
                                <img src={cardBack} alt="Tarot Back" />
                            </div>
                        ))}
                    </div>
                    {/* Zweite Reihe, nur wenn Kartenanzahl > SPLIT_THRESHOLD */}
                    {secondRow.length > 0 && (
                        <div className="tarot-row">
                            {secondRow.map((card, index) => (
                                <div
                                    key={index}
                                    className="tarot-card"
                                    onClick={() => handleCardClick(card)}
                                >
                                    <img src={cardBack} alt="Tarot Back" />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            <div className="selected-cards">
                {selectedCards.map((card, index) => (
                    <div key={index} className="revealed-card">
                        <img src={card.img} alt={card.name} />
                    </div>
                ))}
            </div>

            {showText && (
                <div className="tarot-text">
                    {loading ? <p>Die Karten werden interpretiert...</p> : <p>{tarotText}</p>}
                    {error && <p className="error-text">{error}</p>}
                </div>
            )}

            <button onClick={resetTarot} className="reset-button">
                Tarot neu starten
            </button>
        </div>
    );
};

export default Tarot;
